import HttpLogs from './HttpLogs';

export default HttpLogs;
